/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Provider_OfflineInputs */

const en_voice_manager_provider_offline = /** @type {(inputs: Voice_Manager_Provider_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offline`)
};

const fr_voice_manager_provider_offline = /** @type {(inputs: Voice_Manager_Provider_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hors ligne`)
};

const de_voice_manager_provider_offline = /** @type {(inputs: Voice_Manager_Provider_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offline`)
};

const it_voice_manager_provider_offline = /** @type {(inputs: Voice_Manager_Provider_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offline`)
};

const ru_voice_manager_provider_offline = /** @type {(inputs: Voice_Manager_Provider_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Офлайн`)
};

const es_voice_manager_provider_offline = /** @type {(inputs: Voice_Manager_Provider_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desconectado`)
};

const zh_cn2_voice_manager_provider_offline = /** @type {(inputs: Voice_Manager_Provider_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`离线`)
};

const ja_voice_manager_provider_offline = /** @type {(inputs: Voice_Manager_Provider_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オフライン`)
};

const hi_voice_manager_provider_offline = /** @type {(inputs: Voice_Manager_Provider_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑफलाइन`)
};

const pt_pt2_voice_manager_provider_offline = /** @type {(inputs: Voice_Manager_Provider_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offline`)
};

/**
* | output |
* | --- |
* | "Offline" |
*
* @param {Voice_Manager_Provider_OfflineInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_provider_offline = /** @type {((inputs?: Voice_Manager_Provider_OfflineInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Provider_OfflineInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_voice_manager_provider_offline(inputs)
	if (locale === "de") return de_voice_manager_provider_offline(inputs)
	if (locale === "it") return it_voice_manager_provider_offline(inputs)
	if (locale === "ru") return ru_voice_manager_provider_offline(inputs)
	if (locale === "es") return es_voice_manager_provider_offline(inputs)
	if (locale === "zh-CN") return zh_cn2_voice_manager_provider_offline(inputs)
	if (locale === "ja") return ja_voice_manager_provider_offline(inputs)
	if (locale === "hi") return hi_voice_manager_provider_offline(inputs)
	if (locale === "pt-PT") return pt_pt2_voice_manager_provider_offline(inputs)
	return en_voice_manager_provider_offline(inputs)
});